import { Component, OnInit } from '@angular/core';
import { DataAlertMiniCard } from '../../../interfaces/dash-alerts-interfaces';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';
import { ThemeService } from 'ng2-charts';

@Component({
  selector: 'mini-cards',
  templateUrl: './mini-cards.component.html',
  styleUrls: ['./mini-cards.component.scss'],
})
export class MiniCardsComponent implements OnInit {
  constructor(private resumeService: ResumeService) {}
  statusMinicards: DataAlertMiniCard[];

  ngOnInit() {
    this.getDataMiniCards();
  }
  async getDataMiniCards() {
    await this.resumeService.getDataMiniCards().subscribe((res) => {
      this.statusMinicards = res;
      // this.statusMinicards[0].total = res.created.value
      // this.statusMinicards[1].total = res.created.value
      // this.statusMinicards[2].total = res.created.value
    });
  }
}
